<template>
  <div class="company">
    <div class="banner">
      <img src="../../assets/images/company/banner.png" alt />
    </div>
    <!-- 简介 -->
    <div class="plate">
      <div class="title">EIM简介</div>
      <p>
        易互动(EIM)营销策划有限公司成立于2010年8月，是一家专注于线下互动体验推广传播，客户品牌及产品营销的创意策划与执行同时
        兼具移动互联网技术开发和推广实力的营销服务企业，目前已成为中国西区和北区最强的整合营销传播推广公司之一。
        <br />公司总部设立于成都在北京、重庆设有分公司,其次在昆明、贵阳、西安均设有办事处，业务覆盖中国西部和北部上百个城市。
      </p>
    </div>
    <!-- 公司实力 -->
    <div class="plate">
      <div class="title">公司实力</div>
      <div class="Content">
        <p>
          中国西区最具实力的互动营销推广公司之一
          <br />承接最大单一活动金额超过400万元
          <br />优秀的设计和企划创意能力
        </p>
        <p>
          覆盖大部分一级和二级城市及部分省区三四线城市
          <br />年营业销售额3000+万元
          <br />众多的下游资源与整合能力
        </p>
        <p>
          服务超过30个品牌,其中多数为全球500强品牌
          <br />标准规范的质量与流程系统化管理
        </p>
      </div>
    </div>
    <!-- 业务展示 -->
    <div class="plate business">
      <div class="businessList">
        <div class="Listtitle">
          <strong>EIM案例-</strong>本公司参与世界冠军最多之一的商业活动
        </div>
        <p>吉利汽车签约国家游泳队全国新闻发布会共计20位世界冠军参与</p>
        <div class="businessimg">
          <span>
            <img src="../../assets/images/company/case_01_1.png" alt />
          </span>
          <span>
            <img src="../../assets/images/company/case_01_2.png" alt />
          </span>
        </div>
      </div>
      <div class="businessList">
        <div class="Listtitle">
          <strong>EIM案例-</strong>本公司组织市价最高之一的商业活动
        </div>
        <p>36氪WISE2.0大会，报名10000+人，出席5000人，参与企业总市值超过1.8万亿元</p>
        <div class="businessimg">
          <span>
            <img src="../../assets/images/company/case_02_1.png" alt />
          </span>
          <span>
            <img src="../../assets/images/company/case_02_2.png" alt />
          </span>
        </div>
      </div>
      <div class="businessList">
        <div class="Listtitle">
          <strong>EIM案例-</strong>本公司最好的销售转换价值活动
        </div>
        <p>全新宝马7系列巡展在重庆万豪酒店单场销售6部BNW7系列轿车</p>
        <div class="businessimg">
          <span>
            <img src="../../assets/images/company/case_03_1.png" alt />
          </span>
          <span>
            <img src="../../assets/images/company/case_03_2.png" alt />
          </span>
        </div>
      </div>
    </div>
    <!-- 服务客户 -->
    <div class="plate">
      <div class="title">服务客户</div>
      <p>
        EIM深刻理解全球品牌，在全球品牌推广和执行上经验丰富:服务的品牌中90%以.上为全球知名品牌,且合作稳定,
        EIM的营销服务获得众多全球品牌的认可; EIM的资深营销人员有在知名跨国公司任职、或服务跨国公司10年以上的经验。
      </p>
      <div class="logo">
        <el-carousel
          :height="bannerHeight"
          :interval="5000"
          :arrow="arrow"
          :autoplay="false"
          indicator-position="none"
          ref="carousel"
        >
          <el-carousel-item v-for="item in banner" :key="item" >
            <img :src="item" alt />
          </el-carousel-item>
        </el-carousel>
        <div class="switch">
          <span @click="prev()">
            <img src="../../assets/images/company/left.png" alt />
          </span>
          <span @click="next()">
            <img src="../../assets/images/company/right.png" alt />
          </span>
        </div>
      </div>
      <div class="buttom">
        <div @click="saveNavState(3), $router.push({ path:'/online/H5'})">线上客户案例</div>
        <div @click="saveNavState(4), $router.push({ path:'/underline'})">线下客户案例</div>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
export default {
  data() {
    return {
      banner: [
        require('../../assets/images/company/logo_01.png'),
        require('../../assets/images/company/logo_02.png')
      ],
      screenWidth: document.body.clientWidth
    }
  },
  created() {},
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {
    // 选中线移动函数
    menuSelection(right) {
      anime({
        targets: '.navlist .selectLine',
        right: right
      })
    },
    // 判断选中线移动到指定位置
    navMenu(index) {
      if (index === 0) {
        this.menuSelection('600px')
      } else if (index === 1) {
        console.log(index)
        this.menuSelection('500px')
      } else if (index === 2) {
        this.menuSelection('400px')
      } else if (index === 3) {
        this.menuSelection('300px')
      } else if (index === 4) {
        this.menuSelection('200px')
      } else if (index === 5) {
        this.menuSelection('100px')
      } else if (index === 6) {
        this.menuSelection('0px')
      }
    },
    // 点击切换logo
    prev() {
      this.$refs.carousel.prev()
    },
    next() {
      this.$refs.carousel.next()
    },
    // 保存链接的激活状态
    saveNavState(active) {
      this.navMenu(active)
      window.sessionStorage.setItem('navActive', active)
      this.$emit('active', active)
    }
  },
  computed: {
    bannerHeight() {
      if (this.screenWidth >= 850) {
        return '230px'
      } else {
        return '110px'
      }
    },
    arrow() {
      if (this.screenWidth >= 850) {
        return 'never'
      } else {
        return 'always'
      }
    }
  }
}
</script>

<style scoped>
.company {
  width: 100%;
}
.company .banner {
  width: 100%;
  height: 240px;
  position: relative;
  overflow: hidden;
}
.company .banner img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: auto;
  height: 100%;
}
.company .plate {
  width: 100%;
  max-width: 1100px;
  margin: 10px auto;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.company .plate .title {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  color: rgb(235, 89, 25);
  font-size: 24px;
  padding-top: 8px;
  position: relative;
  margin-bottom: 20px;
}
.company .plate .title::after {
  content: '';
  display: block;
  width: 40px;
  height: 4px;
  background-color: rgb(235, 89, 25);
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
.company .plate p {
  font-size: 14px;
  line-height: 28px;
}
.company .plate .Content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.company .plate .Content p {
  width: 320px;
  margin: 10px 20px;
}
.company .business {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.company .business .businessList {
  width: 320px;
  margin: 10px 20px;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid rgb(220, 220, 220);
}
.company .business .businessList .Listtitle {
  margin-bottom: 20px;
}
.company .business .businessList .Listtitle strong {
  color: rgb(235, 89, 25);
}
.company .business .businessList .businessimg {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.company .business .businessList .businessimg span {
  width: 140px;
  margin-right: 8px;
  height: 98px;
  position: relative;
  overflow: hidden;
}
.businessList .businessimg span:hover img {
  animation: width100_120 1s forwards;
}
.businessList .businessimg span img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  animation: width120_100 1s forwards;
}
.company .plate .logo {
  width: 100%;
  margin: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
@media screen and (min-width: 850px) {
  .company .plate .logo .el-carousel {
    width: 90%;
    height: 230px;
  }
  .company .plate .logo .switch {
    width: 8%;
    background-color: rgb(235, 89, 25);
    height: 40px;
  }
  .company .plate .logo .switch span {
    display: inline-block;
    width: 50%;
    height: 100%;
    position: relative;
  }
  .company .plate .logo .switch span:hover {
    background-color: #727272;
  }
  .logo .switch span img {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (max-width: 849px) {
  .company .plate .logo .el-carousel {
    width: 100%;
  }
  .company .plate .logo .switch {
    display: none;
  }
}

.company .plate .logo .el-carousel img {
  width: 100%;
}

.company .plate .buttom {
  width: 100%;
  display: flex;
  justify-content: center;
}
.company .plate .buttom div {
  width: 160px;
  height: 40px;
  margin: 10px 8px;
  border: 2px solid #000;
  text-align: center;
  font-size: 20px;
  line-height: 40px;
  cursor:pointer;
}
</style>
